/**
 * Auto Open Modal
 *
 * @selector [href^="tel:"]
 * @enabled true
 */
import BaseModule from '../../modules/BaseModule.js';
import BriaAPI, { ApiCallStates } from '../../../app/plugins/BriaAPI.js';

let currentCallId = null;
let currentCallInstance = null;

export default class ENLDirectCall extends BaseModule {
    checkInterval; // Used to check if the callActive parameter is still active

    constructor() {
        super();
        this.nstemp = this.ns + '_temp';
    }
    init(element) {
        this.el = element;
        this.$el = $(this.el);

        if (!navigator.userAgent.includes('KioWare')) {
            // Not in a KioWare browser
            return;
        }

        this.$modal = $('#directcall-modal');
        if (!this.$modal.length) {
            console.warn('No directcall modal found', '#directcall-modal');
            return;
        }

        this.isListenersAdded = false;

        this.BriaAPI = new BriaAPI({
            events: {
                [ApiCallStates.CONNECTING]: this.onCallConnecting.bind(this),
                [ApiCallStates.CONNECTED]: this.onCallConnected.bind(this),
                [ApiCallStates.ENDED]: this.onCallEnded.bind(this),
                //todo: errror handling [and loggedin and out events(?)]
            },
        });
        this.BriaAPI.init();

        this.number = this.$el.attr('href').replace('tel:', '');

        this.on('click', this.onClick);

        return this;
    }

    onCallConnecting(call) {
        if (this.ns !== currentCallInstance) {
            return;
        }

        currentCallId = call.id;
        this.setModalState('CONNECTING');
        this.showModal();
    }
    onCallConnected(call) {
        if (this.ns !== currentCallInstance) {
            return;
        }

        currentCallId = call.id;
        this.setModalState('CONNECTED');
    }
    onCallEnded() {
        if (this.ns !== currentCallInstance) {
            return;
        }

        this.hideModal();
        this.setModalState('ENDED');

        currentCallId = null;
        currentCallInstance = null;
    }

    addEventListeners() {
        if (this.isListenersAdded) return;
        this.isListenersAdded = true;
        this.$modal.find('[data-js-call-action="cancel"]').on('click' + this.nstemp, this.onCancelBtn.bind(this));
        this.$modal.find('[data-js-call-action="key"]').on('click' + this.nstemp, this.onKeyBtn.bind(this));
        this.$modal
            .find('[data-js-call-action="togglenumpad"]')
            .on('click' + this.nstemp, this.onToggleNumpad.bind(this));
        $(document).on('keydown' + this.nstemp, this.onKeyDown.bind(this));
    }
    removeEventListeners() {
        if (!this.isListenersAdded) return;
        this.isListenersAdded = false;

        this.$modal.find('[data-js-call-action="cancel"]').off(this.nstemp);
        this.$modal.find('[data-js-call-action="key"]').off(this.nstemp);
        this.$modal.find('[data-js-call-action="togglenumpad"]').off(this.nstemp);
        $(document).off(this.nstemp);
    }

    onClick(e) {
        e.preventDefault();
        this.setModalState('INIT');
        if (currentCallId === null && currentCallInstance === null) {
            this.startCall();
        } else {
            this.showModal();
        }
    }
    onCancelBtn(e) {
        e.preventDefault();
        this.endCall();
        this.hideModal();
    }
    onKeyBtn(e) {
        e.preventDefault();
        const key = $(e.currentTarget).attr('data-js-call-key');
        this.sendKey(key);
    }
    onKeyDown(e) {
        if (e.key === 'Escape') {
            this.endCall();
            this.hideModal();
        }
        // if phone key is pressed (1, 2, 3, 4, 5, 6, 7, 8, 9, * or #)
        if (e.key.match(/^[0-9*#]$/)) {
            this.sendKey(e.key);
        }
    }
    onToggleNumpad(e) {
        e.preventDefault();
        this.$modal.find('[data-js-call-numpad]').toggleClass('visible');
    }

    // Bria API
    startCall() {
        currentCallInstance = this.ns;
        this.number && this.BriaAPI.apiPlaceCall(this.number, true);
    }
    endCall() {
        currentCallId && this.BriaAPI.apiEndCall(currentCallId);
    }
    sendKey(key) {
        key && currentCallId && this.BriaAPI.apiSendKey(key);
    }

    // Modal handling
    showModal() {
        this.$modal.modal({
            backdrop: 'static',
            keyboard: false,
            show: true,
        });
        this.addEventListeners();
        this._appendActiveCallStateToURL();
    }
    hideModal() {
        this.removeEventListeners();
        this.$modal.modal('hide');
        this.$modal.find('[data-js-call-numpad]').removeClass('visible');
        this._removeActiveCallStateFromURL();
    }
    setModalState(state) {
        this.$modal.find('[data-js-call]').attr('data-call-state', state);
    }

    /**
     * The following methods are used to append and remove the callActive state to the URL
     * This is used to prevent the Kiosk from going to sleep while a call is active
     */
    _appendActiveCallStateToURL() {
        const currentUrl = window.location.href;
        const stringToCheck = 'callActive';

        if (currentUrl.includes(stringToCheck)) {
            console.log('The current URL contains the string ' + stringToCheck + ' already');
        } else {
            const newUrl = currentUrl + '?callActive=true';
            history.replaceState({}, '', newUrl);
        }

        this.checkInterval = setInterval(this._checkCallActive, 5000); // Check every 5 seconds
    }

    _removeActiveCallStateFromURL() {
        const currentUrl = window.location.href;
        const stringToCheck = 'callActive';

        if (currentUrl.includes(stringToCheck)) {
            const newUrl = currentUrl.replace('?callActive=true', '');
            history.replaceState({}, '', newUrl);
        } else {
            console.log('The current URL does not contain the string ' + stringToCheck);
        }

        clearInterval(this.checkInterval);
    }

    _checkCallActive() {
        if (window.location.href.indexOf('callActive') > -1) {
            try {
                /// See more: https://m.kioware.com/api/windows/8.30/javascript/kioutils/nudgemouse
                KioUtils.NudgeMouse();
                console.log('Found active call parameter. Keeping session alive using KioWare NudgeMouse');
            } catch (e) {
                console.error('Error while trying to use NudgeMouse from KioWare: ' + e);
            }
        }
    }
}
